import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/enrollment';
import * as enrollmentPageActions from '../actions/enrollment';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { EnrollmentService } from '../../api/enrollment-service';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import Translator from '../../core/i18n';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';

const T = Translator.create();
const _logger = Log.create('Enrollment Saga');
const _enrollmentService = new EnrollmentService();
const _cacheService = new CacheService();

//#region "Add Assignment Activity Saga"
function* setEnrollmentActivity(params: any): any {
    try {
        // yield put(coursePageActions.setCoursePageHeaderInformationData(nullData, [], false));
        const pageData = yield _enrollmentService.RequestGetEnrollmentActivityAsync(params.activityId).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });
        if (params.activityId && params.activityId !== '0') {
            if (pageData && pageData.length > 0) {
                yield put(enrollmentPageActions.setRefreshMyEnrollments(pageData));

            }

        }
        else {
            yield put(enrollmentPageActions.enrollmentSetAction(pageData));

        }
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        yield put(enrollmentPageActions.enrollmentSetAction(null));
    }
}

function* addEnrollmentActionLog(params: any): any {
    try {
        // yield put(coursePageActions.setCoursePageHeaderInformationData(nullData, [], false));
        const pageData = yield _enrollmentService.RequestAddEnrollmentActionAsync(params.actionData).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {

                return data;
            }
        });
        yield put(enrollmentPageActions.enrollmentSetState(pageData));

        if (pageData && pageData.length > 0) {
            yield put(enrollmentPageActions.setRefreshMyEnrollments(pageData));

        }
        if (params.callback) {
            params.callback();
        }
        // yield put(enrollmentPageActions.enrollmentSetAction(pageData));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        // yield put(enrollmentPageActions.enrollmentSetAction(null));
    }
}

function* getMyGrades(params: any): any {
    let isError = false;
    let errorList: any;
    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };
    if (params.Filters.lastActivityId) {
        try {
            const pageData = yield _enrollmentService.RequestGetMyGradesAsync(params.Filters).then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(enrollmentPageActions.getMyGradesSetAction(pageData, params.spinnerId, 'set', params.Filters.lastActivityId ? true : false));
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
        }
    } else {
        if (!_cacheService.CheckCache(cacheData)) {
            _cacheService.AddOrUpdateActionRequest(cacheData);
            try {
                const pageData = yield _enrollmentService.RequestGetMyGradesAsync(params.Filters).then((responseData: Response) => {
                    return responseData;
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });

                if (isError) {
                    errorList ?
                        Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        }) : Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
                }

                if (!isError) {
                    if (pageData.length <= 0 && (params.lastActivityId !== null || params.lastActivityId !== '')) {
                        params.lastActivityId = '';
                        // tslint:disable-next-line:no-shadowed-variable
                        const pageData = yield _enrollmentService.RequestGetMyGradesAsync(params.Filters).then((responseData: Response) => {
                            return responseData;
                        }).then((responseData: Response) => {
                            if (responseData.status !== 200) {
                                isError = true;
                            }
                            return responseData.json();
                        }).then((response) => {
                            if (isError) {
                                errorList = response;
                            } else {
                                return response;
                            }
                        });

                        if (isError) {
                            errorList ?
                                Object.keys(errorList).forEach((key: any) => {
                                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                                }) : Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
                        }
                        if (!isError) {
                            yield put(enrollmentPageActions.getMyGradesSetAction(pageData, params.spinnerId, 'set'));
                        }
                    } else {
                        yield put(enrollmentPageActions.getMyGradesSetAction(pageData, params.spinnerId, 'set'));
                    }
                }
            } catch (error: any) {
                Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
            }
        } else {
            try {
                const pageData = yield _enrollmentService.RequestGetMyGradesAsync(params.Filters).then((responseData: Response) => {
                    return responseData;
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });

                if (isError) {
                    errorList ?
                        Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        }) : Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
                }

                if (!isError) {
                    yield put(enrollmentPageActions.getMyGradesSetAction(pageData, params.spinnerId, 'set'));
                }
            } catch (error: any) {
                Notification.setNotification('error', T.t('r_enrollment_page_my_grades_error_message'), 'topRight');
            }
        }
    }
}

function* getRefreshMyEnrollments(): any {
    try {
        const pageData = yield _enrollmentService.RequestRefreshMyEnrollments().then((responseData: Response) => {
            return responseData;
        }).then((data: any) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });
        if (pageData && pageData.length > 0) {
            yield put(enrollmentPageActions.setRefreshMyEnrollments(pageData));

        }
        // tslint:disable-next-line: no-empty
    } catch (error: any) {

    }
}

export function* watchGetEnrollmentData() {
    yield takeEvery(constants.actions.ENROLLMENT_GETDATA, setEnrollmentActivity);
    return null;
}
export function* watchaddEnrollmentActionLog() {
    yield takeEvery(constants.actions.ENROLLMENT_ADDACTIONLOG, addEnrollmentActionLog);
    return null;
}

export function* watchGetMyGrades() {
    yield takeEvery(constants.actions.GET_MY_GRADES, getMyGrades);
}

export function* watchGetRefreshMyEnrollments() {
    yield takeEvery(constants.actions.GET_REFRESH_MY_ENROLLMENTS, getRefreshMyEnrollments);
}

//#endregion "Add Assignment Activity End Saga"

export function* EnrollmentSagas() {
    yield all([
        watchGetEnrollmentData(),
        watchaddEnrollmentActionLog(),
        watchGetMyGrades(),
        watchGetRefreshMyEnrollments()
    ]);
}